import React,{useState,useEffect,useCallback} from 'react'
import { useParams } from 'react-router-dom'
import Loading from '../common/Loading'
import surveyService from '../../services/survey.service'
import EcxSurveyEditor from '../helpers/ecxsurvey/EcxSurveyEditor'
import { useSurveyStore } from '../helpers/ecxsurvey/surveyutilities/surveyStore'
import { toast } from 'react-toastify'

function SurveyEdit() {
  const {surveyId} = useParams()
  const exportToJSON = useSurveyStore(state => state.exportToJSON)
  const loadSurveyData = useSurveyStore(state => state.loadSurveyData)
  const resetStore = useSurveyStore(state => state.resetStore)
  const [loading,setLoading] = useState(false)

  const getSurveyInfo = useCallback(()=>{
    setLoading(true)
    surveyService.getEcxSurveyById(surveyId)
    .then(res=>{
       loadSurveyData(res.data)
       setLoading(false)
    })
    .catch(err=>{
      setLoading(false)
    })
  },[surveyId,loadSurveyData])

  useEffect(()=>{
    resetStore()
    getSurveyInfo()
  },[surveyId,resetStore,getSurveyInfo])

  const handleSave = async () => {
    try {
      const surveyData = exportToJSON();
      
      const requestData = {
        ...surveyData
      };
      
      const response = await surveyService.updateEcxSurvey(surveyId, requestData);
      console.log('Survey updated successfully:', response.data);
      toast.success('Survey updated successfully!');
    } catch (error) {
      console.error('Error updating survey:', error);
      toast.error('Failed to update survey. Please try again.');
    }
  }

  return (
    <>
    {loading ? <Loading/>:
   
   <EcxSurveyEditor onSave={handleSave} />}
    </>
  )
}

export default SurveyEdit